import { BeconCommonTypes } from "@becon-team/becon-fe-lib/my-types";
import { i18n as I18nType } from "i18next";

export const getCheckKoreaLang = (i18n: I18nType): boolean => {
  const primaryLanguage = i18n.languages[0].toLowerCase();
  return primaryLanguage === "kr" || primaryLanguage === "ko";
};

export const getCheckAccountRegionKorea = (region: BeconCommonTypes.RegionEnum) => {
  return region === BeconCommonTypes.RegionEnum.KR;
};
